var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-carousel',_vm._g(_vm._b({ref:"carouselRef",attrs:{"autoplay":_vm.autoplay}},'el-carousel',_vm.$attrs,false),_vm.Listeners),[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }